import React, { useEffect, useState } from "react";
import { useConfigurationOptionsContext } from "../../../../../../../app/providers/DoorOptionsProvider";
import { Vector3 } from "three";
import { BeamData } from "../../../../../../../app/providers/DoorOptionsProvider.types";
import { DoorGlassMaterial } from "shared/utils/door";
import { lockSettings } from "shared/utils/doorConfigurations";
import { getFullAssetPath } from "shared/utils/assets";
import { useGLTF } from "@react-three/drei";
import {
  defaultDoorWidth,
  defaultLockHandleYPosition,
  defaultLockHeight,
  defaultSideFrameWidth,
} from "shared/utils/doorSceneConstants";
import { SilverHandlesGLTFResult } from "../../enkel/handlesType";

interface HandleProps extends lockSettings {
  doorNodes: any;
  materials: DoorGlassMaterial;
  secondary?: boolean;
  reverse?: boolean;
  type: string;
  index: number;
}

const Handle: React.FC<HandleProps> = ({
  doorNodes,
  materials,
  secondary,
  reverse,
  type,
  index,
  ...props
}: HandleProps) => {
  const { handle } = useConfigurationOptionsContext();

  const { nodes: nodesHandle, materials: materialsHandle } = useGLTF(
    getFullAssetPath("/objects-v3/kaderdeurSilverHandles-v1.glb"),
  ) as SilverHandlesGLTFResult;

  // Determine handle color based on handle type (zwart, rvsilver)
  const handleColor = handle?.code.includes("zwart")
    ? materials["PoedercoatGitZwart"]
    : materialsHandle.MergedBake_Baked;

  // Show handle lock based on handle type
  const showHandleLock =
    handle?.code.includes("cilinder") || handle?.code.includes("toilet");

  return (
    <group rotation-y={false ? Math.PI : 0}>
      {/* Handles */}

      <mesh
        castShadow
        receiveShadow
        geometry={nodesHandle.handle_1_Baked.geometry}
        material={handleColor}
        visible={showHandleLock}
        position={[-0.421 + 0.46, 0.984, 0.001]}
      />

      <mesh
        castShadow
        receiveShadow
        geometry={nodesHandle.handle_0_Baked.geometry}
        material={handleColor}
        position={[-0.393 + 0.46, 1.073, 0]}
      />

      {/* Handles end */}
    </group>
  );
};

export default Handle;
